import React from 'react'
import { Button, Icon } from 'components'
import { theme } from 'global'
import { trackButtonInteraction } from 'api/tracking'

interface ICardDownloader {
  imgs: string[]
  selected: number
  btnText?: string
}

export const CardDownloader = ({
  imgs,
  selected,
  btnText,
}: ICardDownloader) => {
  const [loading, setLoading] = React.useState(false)

  // Download selected card as PNG
  const handleDlCard = () => {
    if (!loading) {
      setLoading(true)
      const card = imgs[selected]
      const fileName = `orgasm-order-card-${selected + 1}`
      const a = document.createElement('a')
      a.href = card
      a.download = fileName
      a.click()
      setTimeout(() => setLoading(false), 500)
      trackButtonInteraction('Download Card Button', 'Click')
    }
  }

  return (
    <>
      {selected >= 0 && (
        <Button
          full
          thin
          maxWidth='290px'
          margin={1}
          variant='link'
          icon={
            <Icon name='download' viewBox='29' size='26px' marginRight={2} />
          }
          color={theme.colors.linkTextGrey}
          loading={loading}
          disabled={loading}
          onClick={handleDlCard}
        >
          {btnText || 'Download Card'}
        </Button>
      )}
    </>
  )
}
